"use client";
import React, { forwardRef, useRef, useState } from "react";

import { useTranslations } from "next-intl";

import BaseInput, { BaseInputProps } from "@/ui/Forms/BaseInput";

interface FormDatepickerProps
  extends Omit<BaseInputProps, "onChange" | "type"> {
  value?: string;
  onChange?: (value: string) => void;
  min?: string;
  max?: string;
}

/**
 * FormDatepicker component
 * Date picker component using HTML5 date input with NextUI styling
 */
const FormDatepicker = (
  {
    name,
    label,
    placeholder,
    value = "",
    onChange,
    error,
    required = false,
    disabled = false,
    className = "",
    errorClassName,
    min,
    max,
    ...props
  }: FormDatepickerProps,
  // ref: ForwardedRef<HTMLInputElement>,
) => {
  const t = useTranslations();
  const [selectedDate, setSelectedDate] = useState<string>(
    value ? new Date(value).toISOString().split("T")[0] : value,
  );
  const ref = useRef<HTMLInputElement | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    const finalValue = newValue === "" ? undefined : newValue;
    setSelectedDate(finalValue ?? "");
    onChange?.(finalValue);
  };

  return (
    <BaseInput
      onClick={() => ref.current?.showPicker?.()}
      ref={ref}
      type="date"
      name={name}
      label={label}
      // value={value ? new Date(value).toISOString().split("T")[0] : undefined}
      value={selectedDate || ""}
      onChange={handleChange}
      placeholder={placeholder || t("Select date")}
      disabled={disabled}
      error={error}
      required={required}
      min={min}
      max={max}
      className={className}
      errorClassName={errorClassName}
      {...props}
    />
  );
};

const FormDatepickerComponent = forwardRef(FormDatepicker);

export { FormDatepickerComponent as FormDatepicker };
export default FormDatepickerComponent;
